export interface Session {
    id: string;
    createdAt: Date;
}
